import * as d3 from 'd3';
import _ from 'lodash';
import { Granularity } from '../../models';
import React from 'react';
import { IChartTimeline } from './models';
import { createScales } from './util';
import * as S from './y-axis.styles';

export interface IYAxisProps {
    chartRect: ClientRect;
    granularity: Granularity;
    timeline: IChartTimeline;
}

export class YAxis extends React.Component<IYAxisProps> {
    public render(): React.ReactElement {
        const { chartRect, granularity, timeline } = this.props;
        const yScale = createScales(timeline, granularity, chartRect)[1];
        const yAxisTicks = yScale.ticks(5);
        const noLabels = yScale.domain()[1] === Number.MAX_VALUE;
        const lines = _.map(yAxisTicks, (tick: number) => {
            return <S.YAxisLine key={tick} x1={0} y1={yScale(tick)} x2={chartRect.width} y2={yScale(tick)} />;
        });
        const format = d3.format('$,~s');
        const labels = _.map(yAxisTicks, (tick: number) => {
            if (noLabels) {
                return;
            }
            return (
                <S.YAxisLabel key={tick} x={0} y={yScale(tick)} dy={-6}>
                    {format(tick)}
                </S.YAxisLabel>
            );
        });
        return (
            <S.YAxis>
                {lines}
                {labels}
            </S.YAxis>
        );
    }
}
